module.exports = __webpack_public_path__ + "static/media/check1st.205a4f77.svg";